export const GET_CORALOGIX_SUBSYSTEMS = "GET_CORALOGIX_SUBSYSTEMS";
export const GET_CORALOGIX_SUBSYSTEMS_SUCCESS = "GET_CORALOGIX_SUBSYSTEMS_SUCCESS";
export const GET_CORALOGIX_SUBSYSTEMS_FAIL = "GET_CORALOGIX_SUBSYSTEMS_FAIL";

export const POST_SUBSYSTEMS_SERVICE_MAPPING = "POST_SUBSYSTEMS_SERVICE_MAPPING";
export const POST_SUBSYSTEMS_SERVICE_MAPPING_SUCCESS = "POST_SUBSYSTEMS_SERVICE_MAPPING_SUCCESS";
export const POST_SUBSYSTEMS_SERVICE_MAPPING_FAIL = "POST_SUBSYSTEMS_SERVICE_MAPPING_FAIL";